<script setup lang="ts">
const { data } = await useFetch('/api/packages')
const packages = computed(() => {
  return data.value?.tiers?.map(pkg => ({
    ...pkg,
    id: String(pkg.id)
  })) ?? []
})
const features = computed(() => data.value?.sections ?? [])
</script>

<template>
  <section id="pacchetti" class="bg-white dark:bg-slate-950">
    <UContainer class="py-14 md:py-20">
      <div class="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div class="max-w-2xl">
          <h2 class="text-2xl font-semibold text-slate-900 dark:text-white md:text-3xl">
            Scegli il tuo pacchetto
          </h2>
          <p class="mt-3 text-slate-600 dark:text-slate-300">
            Tre livelli chiari: basi solide, performance, supporto totale. Puoi fare upgrade quando vuoi.
          </p>
        </div>

        <UBadge
          class="w-fit border border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-200"
        >
          Pagamento mensile · disdici quando vuoi
        </UBadge>
      </div>
      <div class="mt-10">
        <UPricingTable :tiers="packages" :sections="features" />
      </div>
    </UContainer>
  </section>
</template>

<style scoped>

</style>
